import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';

const state = {
    fechaCreditoDebito: moment(new Date()).format('YYYY-MM-DD'),
    bancoCuentaId: 0,
    bancoCuenta: null,
    bancoCuentaNombre: null,
    importe: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.fechaCreditoDebito = moment(new Date()).format('YYYY-MM-DD');
        state.bancoCuentaId = 0;
        state.bancoCuenta = null;
        state.bancoCuentaNombre = null;
        state.importe = 0;
    },
    'SET_BANCO_CUENTA'(state, bancoCuenta) {
        state.bancoCuenta = bancoCuenta;
        state.bancoCuentaId = bancoCuenta ? bancoCuenta.id : 0;
        state.bancoCuentaNombre = bancoCuenta ? bancoCuenta.nombre.trim() : null;
    },
};

const getters = {
    getField,

    deposito (state) {
        return {
            fechaCreditoDebito: moment(state.fechaCreditoDebito).format('YYYY-MM-DD'),
            bancoCuentaId: parseInt(state.bancoCuentaId),
            bancoCuenta: state.bancoCuenta,
            bancoCuentaNombre: state.bancoCuentaNombre,
            importe: parseFloat(state.importe),
        }
    }
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');
            resolve();
        })
    },
    setBancoCuenta: ({commit}, bancoCuenta) => {
        commit('SET_BANCO_CUENTA', bancoCuenta);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}